import React from 'react'
import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import TrophySvg from 'images/icons/fc-marketing/trophy.svg'
import makeStyles from '@material-ui/core/styles/makeStyles'
import clsx from 'clsx'
import { useStandings, isWinner } from './utils'
import useIsMobile from 'components/program-marketing/useIsMobile'

const useStyles = makeStyles(theme => ({
  table: {
    borderSpacing: '0 8px',
    borderCollapse: 'separate',
    border: 'none',
    '& td, & th': {
      border: 'none',
    },
    '& td': {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '18px',
      lineHeight: '23px',
    },
    '& tr': {
      background: '#FFFFFF',
      boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.03)',
      borderRadius: '10px',
    },
    '& td:first-child': {
      borderTopLeftRadius: '10px',
      borderBottomLeftRadius: '10px',
    },
    '& td:last-child': {
      borderTopRightRadius: '10px',
      borderBottomLeftRadius: '10px',
    },
  },
  orangeFont: {
    color: theme.palette.primary.main,
  },
}))

const WinnerChip = () => (
  <Chip
    label="Winner!"
    variant="outlined"
    color="primary"
    icon={<img src={TrophySvg} alt="trophy" style={{ color: 'inherit' }} />}
  />
)

const TableHeaderCell = ({ children, align = 'left', width = 45 }) => {
  const classes = useStyles()
  return (
    <TableCell
      className={classes.tableCell}
      align={align}
      style={{ maxWidth: width }}
    >
      {children}
    </TableCell>
  )
}

const LeaderBoard = ({ program, events }) => {
  const isMobile = useIsMobile()
  const classes = useStyles()
  const standings = useStandings(program, events)

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="leaderboard">
        <TableHead>
          <TableRow
            style={{
              border: 'none',
              background: 'none',
              boxShadow: 'none',
            }}
          >
            <TableHeaderCell>Rank</TableHeaderCell>
            <TableHeaderCell />
            {events.map((_, index) => (
              <TableHeaderCell key={index} align="right">
                M{index + 1}
              </TableHeaderCell>
            ))}
            <TableHeaderCell align="right">Total</TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {standings.map(team => {
            const winner = isWinner(team)

            return (
              <TableRow key={team.name} className={classes.tableRow}>
                <TableCell align="left">{team.rank}</TableCell>
                <TableCell align="left">
                  <Box display="inline-block" mr={'12px'} mb={isMobile ? 1 : 0}>
                    {team.name}
                  </Box>
                  {winner && <WinnerChip />}
                </TableCell>
                {team.scores.map((score, index) => (
                  <TableCell key={index} align="right">
                    {score}
                  </TableCell>
                ))}
                <TableCell
                  align="right"
                  className={clsx({ [classes.orangeFont]: winner })}
                >
                  {team.total}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default LeaderBoard
